import { Component } from '@angular/core';

@Component({
  selector: 'app-job-faqs',
  templateUrl: './job-faqs.component.html',
  styleUrls: ['./job-faqs.component.css']
})
export class JobFaqsComponent {
   // Set Topbar Option
   Menuoption = 'job';
  Settingicon = true;
  navClass = "nav-light";
}
